var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoCapture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "photo-capture",
    d: "M13.5,9A4.5,4.5,0,1,0,9,13.5,4.5,4.5,0,0,0,13.5,9ZM9,12a3,3,0,1,1,3-3A3,3,0,0,1,9,12ZM6,17.25a.749.749,0,0,1-.75.75H3.75A3.754,3.754,0,0,1,0,14.25v-1.5a.75.75,0,0,1,1.5,0v1.5A2.253,2.253,0,0,0,3.75,16.5h1.5A.749.749,0,0,1,6,17.25Zm12-4.5v1.5A3.754,3.754,0,0,1,14.25,18h-1.5a.75.75,0,0,1,0-1.5h1.5a2.253,2.253,0,0,0,2.25-2.25v-1.5a.75.75,0,0,1,1.5,0Zm0-9v1.5a.75.75,0,0,1-1.5,0V3.75A2.253,2.253,0,0,0,14.25,1.5h-1.5a.75.75,0,0,1,0-1.5h1.5A3.754,3.754,0,0,1,18,3.75ZM0,5.25V3.75A3.754,3.754,0,0,1,3.75,0h1.5a.75.75,0,0,1,0,1.5H3.75A2.253,2.253,0,0,0,1.5,3.75v1.5a.75.75,0,0,1-1.5,0Z",
    fill: "#26b9db"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCapture);
export default __webpack_public_path__ + "static/media/photo-capture.e19cea229e2085f6c6935f98e21e3d4d.svg";
export { ForwardRef as ReactComponent };